module.exports = __webpack_public_path__ + "img/geo-zones-2.e35a196e.gif";